import { fmtMoney } from "@/engine/format/esMX";
import type { SnapshotRow } from "@/types/db";
import type { Currency } from "@/engine/types";
import { compareProgress, type ProgressRow } from "@/ai/compare";

/** Evolución entre fotos (v_my_progress). */
export function evolucion(rows: Partial<SnapshotRow>[], currency = "MXN") {
  const puntos = rows.filter((r) => r.created_at).map((r) => ({ fecha: r.created_at as string, etiqueta: r.label ?? undefined, valor: r.net_worth === null || r.net_worth === undefined ? null : Number(r.net_worth) }));
  const conValor = puntos.filter((p) => p.valor !== null);
  const fecha = (f: string) => new Date(f).toLocaleDateString("es-MX", { day: "numeric", month: "short" });
  if (conValor.length === 0) return { estado: "vacio" as const, lectura: "", puntos };
  if (conValor.length === 1) return { estado: "parcial" as const, lectura: `Esta es tu primera foto (${fecha(conValor[0].fecha)}). Cuando guardes la siguiente verás aquí tu evolución.`, puntos };
  const a = conValor[0], b = conValor[conValor.length - 1];
  const d = (b.valor as number) - (a.valor as number);
  const cur = currency as "MXN" | "USD";
  return { estado: "ok" as const, lectura: `Tu patrimonio neto pasó de ${fmtMoney(a.valor, cur)} a ${fmtMoney(b.valor, cur)} entre ${fecha(a.fecha)} y ${fecha(b.fecha)} (${d >= 0 ? "+" : "−"}${fmtMoney(Math.abs(d), cur)}).`, puntos };
}

/** "Tu foto de entrada vs hoy": compara la foto elegida (por default la primera) contra la vigente. */
export function comparacion(rows: Partial<SnapshotRow>[], desdeId: string | null, currency = "MXN") {
  const xs = rows.filter((r) => r.created_at) as unknown as ProgressRow[];
  if (xs.length < 2) return { estado: "vacio" as const, lectura: "", datos: null, opciones: [] as { id: string; etiqueta: string }[] };
  const b = xs[xs.length - 1];
  const a = xs.find((r) => r.id === desdeId && r !== b) ?? xs[0];
  const c = compareProgress(a, b, currency as Currency);
  const nw = c.deltas.find((d) => d.key === "net_worth")!, sr = c.deltas.find((d) => d.key === "savings_rate")!;
  const lectura = `Del ${c.from.date} al ${c.to.date} (${c.days_between} días): patrimonio neto ${nw.change}, tasa de ahorro ${sr.change}.`;
  const opciones = xs.slice(0, -1).map((r) => ({ id: r.id as string, etiqueta: `${new Date(r.created_at).toLocaleDateString("es-MX", { day: "numeric", month: "short", year: "numeric" })}${r.label ? ` · ${r.label}` : ""}` }));
  return { estado: "ok" as const, lectura, datos: c, opciones, desde: a.id as string };
}
